import { Component, Inject, OnInit } from '@angular/core';
import { Validators, ValidatorFn, AbstractControl, FormControl } from '@angular/forms';
import { 
    DwComponent, DwComponentType, DwSectionBaseComponent, DwUiConfigRegistryService, DwUIMetaDataConfig, DwUIMetaDataConfigToken, 
    DwMetaDataFormStateService, DwExpressionService, DwMetaDataService, DwMetaDataServiceToken, DwMenuService,
    DwFormActionInterceptor, DwActionPreference, DwFormActionConfig, DwFormActionInterceptResult, DwFormActionKeys, DwMessageSeverity  } from '@devwareapps/devware-cap';
import { of } from 'rxjs';
import { StarRatingFieldExperienceEntity, SurveysMetaDataItemNames, SurveysMetaDataService } from '../surveys/meta-data/surveys-meta-data.service';

@DwComponent(
  {
    key: 'survey-validators',
    name: 'Survey Validator',
    componentType: DwComponentType.formSection,
    isGlobal: false,
    parentItemName: SurveysMetaDataItemNames.StarRatingFieldExperience
  }
)
@Component({
  selector: 'survey-validators',
  templateUrl: './survey-validators.component.html',
  styleUrls: ['./survey-validators.component.scss']
})
export class SurveyValidatorsComponent extends DwSectionBaseComponent {

  constructor(
    dwExpressionService: DwExpressionService,
    protected dwUiConfigRegistryService: DwUiConfigRegistryService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    private dwMetaDataFormStateService: DwMetaDataFormStateService,
    private dwMenuService: DwMenuService,
  ) {
    super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
  }

  setupComponentComplete(): void {
    this.dwMetaDataFormStateService.addActionInterceptor(this.getFormActionInterceptor())
  }

  getFormActionInterceptor(): DwFormActionInterceptor {

    const dwMetaDataFormStateService = this.dwMetaDataFormStateService;

    const interceptor: DwFormActionInterceptor = {
      interceptorName: 'survey-action-interceptor',
      onBeforeAction: (actionPref: DwActionPreference<DwFormActionConfig>, actionConfig: any) => {

        const result: DwFormActionInterceptResult = {
          abort: false
        }
        if (actionPref.actionKey != DwFormActionKeys.formSave && actionPref.actionKey != DwFormActionKeys.formWorkflow) {
          return of(result);
        }

        const survey:  StarRatingFieldExperienceEntity = dwMetaDataFormStateService.state.formApi.getFormData();

        /* Check for Rating validation errors */
        const errors = this.getValidationErrors(survey);

        if (errors.length > 0) {
           result.abort = true;
           result.message = {
             messageHeading: errors[0],
             severity: DwMessageSeverity.error,
           }
        }
        return of(result);
      },
      onAfterAction: (actionPref: DwActionPreference<DwFormActionConfig>, actionConfig: any, actionResult: any) => {

        const result: DwFormActionInterceptResult = {
          abort: false
        }
        const isSave = actionPref.actionKey == DwFormActionKeys.formSave;
        /* Continue unaffected if not targeted action */
        if (!isSave) {
          return of(result);
        }
       return of(result);
      },
    }
    return interceptor;
  }
  getValidationErrors(survey: StarRatingFieldExperienceEntity): string[] {
    const errors: string[] = [];

    const rutRoh = survey.SupportScore == 1 || survey.OverallScore == 1 || survey.ResponsivenessScore == 1 || survey.SchedulingScore == 1;
    const comments = survey.AdditionalComments;

    if (rutRoh && (!comments || comments.trim().length == 0)){
      errors.push('Additional comments required if assigning a 1-star rating. Thank you!');
    }
    return errors;
  }
}